/*
 * Copyright (c) 2022. Haodong JU
 */

import hillo from 'hillo'
import GlobalSettings from '@/GlobalSettings'
import Swal from 'sweetalert2'
import i18n from '@/i18n'
import Dish from '@/model/dish/Dish'

export function formatDate (num) {
  const now = new Date()
  const nowTime = now.getTime()
  const oneDayTime = 24 * 60 * 60 * 1000
  const ShowTime = nowTime + num * oneDayTime
  const myDate = new Date(ShowTime)
  const y = myDate.getFullYear()
  const m = myDate.getMonth() + 1
  const d = myDate.getDate()
  return [y, m, d].join('-')
}

export function formatFullData (num) {
  const now = new Date()
  const nowTime = now.getTime()
  const oneDayTime = 24 * 60 * 60 * 1000
  const ShowTime = nowTime + num * oneDayTime
  const myDate = new Date(ShowTime)
  const y = myDate.getFullYear() + '-'
  const m = myDate.getMonth() + 1
  const d = myDate.getDate()
  const h = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours()
  const mm = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes()
  const s = myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds()
  return y + m + '-' + d + ' ' + h + ':' + mm + ':' + s
}

export function rundTimeSecondToMin (item) {
  const temp = item
  if (temp.maxDineTime) temp.maxDineTime = temp.maxDineTime / 60
  if (temp.roundTime) temp.roundTime = temp.roundTime / 60
  // if(item.)
  return temp
}

export async function loadDashboardData (startDate, endDate) {
  return await hillo.get('DashboardData.php', {
    lang: GlobalSettings.getLang(),
    startDate,
    endDate,
  })
}

export async function loadZBonList (startDate, endDate) {
  return (await hillo.get('ZBon.php?op=searchZBonInDaySpan', {
    startDate,
    endDate,
  })).content
}

export async function checkDishDetail (id) {
  const res = (await hillo.get('Dishes.php?op=withMod', { id })).content
  res.name = res.langs.find(it => it.lang.toLowerCase() === GlobalSettings.lang.toLowerCase())?.name ?? ''
  return res
}

export async function toggleAttributeGroup (agId, dishesId) {
  const item = (await Dish.getList()).find(it => it.dishId === dishesId)
  if (item.attributeGroupId.includes(agId)) {
    item.attributeGroupId = item.attributeGroupId.filter(it => it !== agId)
  } else {
    item.attributeGroupId.push(agId)
  }
  await Dish.edit(item)
}

export async function flipAttributes (id, agId, aId) {
  return (await hillo.post('Dishes.php?op=flipAttributes', {
    idAgIdAIds: JSON.stringify([{
      id,
      agId,
      aId,
    }]),
  })).content
}

export function getColorLightness (c) {
  if (c?.startsWith('#')) {
    if (c.length < 5) {
      c += 'fff'
    }
    const rgb = parseInt(c.substring(1), 16) // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff // extract red
    const g = (rgb >> 8) & 0xff // extract green
    const b = (rgb >> 0) & 0xff // extract blue
    return 0.2126 * r + 0.7152 * g + 0.0722 * b
  } else {
    return 0
  }
}

export async function fastSweetAlertRequest (title, input, url, dataName, dataObj, method = 'POST', allowEmpty = false, body = null, inputValue = '') {
  dataObj[dataName] = ''
  const callBack = function (method, data) {
    const request = method === 'POST' ? hillo.post : hillo.silentGet
    dataObj[dataName] = data
    return request(url, dataObj, { silent: true })
      .then(response => {
        return response
      })
      .catch(error => {
        Swal.showValidationMessage(`Request failed: ${error?.data?.info ?? i18n.t('error')}`)
      })
  }

  const result = await Swal.fire({
    title: title,
    html: body,
    input: input,
    inputAttributes: {
      autocapitalize: 'off',
    },
    inputValue: inputValue,
    showCancelButton: true,
    confirmButtonText: i18n.t('confirm'),
    cancelButtonText: i18n.t('cancel'),
    showLoaderOnConfirm: true,
    preConfirm: (data) => {
      if (!data && !allowEmpty) {
        return false
      }
      return callBack(method, data)
    },
    allowOutsideClick: () => !Swal.isLoading(),
  })
  if (result.value || allowEmpty) {
    result.value.originalData = dataObj[dataName]
    return result.value
  } else {
    return false
  }
}

